<template>
  <div>
    <v-data-table :loading="loading" :headers="headers" :items="Discounts.data" class="elevation-1" hide-default-footer>
      <template v-slot:[`item.is_active`]="{ item }">
        <v-icon v-if="item.is_active == 1" color="success">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:[`item.membership`]="{ item }">
        <span v-if="item.membership == 1" color="success">Yes</span>
        <span v-else color="success">No</span>
      </template>
      <template v-slot:no-data> No data </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon color="warning" class="mr-2" @click.stop="edit(item)">
          mdi-pencil-box-outline
        </v-icon>
      </template>

      <template v-slot:top>
        <v-row dense class="mx-2">
          <base-column :lg="4" :md="4" :sm="12">
            <v-text-field v-model="search.search" append-icon="mdi-magnify" label="Search" outlined dense
              hide-details></v-text-field>
          </base-column>
          <base-column :lg="3" :md="4" :sm="12" v-if="(ROLE == 'Owner')">
            <v-select v-model="search.branch_id" :items="branch" item-text="name" item-value="id" label="Branch" outlined
              dense></v-select>
          </base-column>
          <base-column :lg="3" :md="4" :sm="12">
            <v-btn small color="darkblue" class="white--text" @click.stop="searching">Submit <v-icon
                right>mdi-magnify</v-icon></v-btn>
            <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
              <v-icon right>mdi-close-circle-multiple </v-icon>
            </v-btn>
          </base-column>
        </v-row>
      </template>
    </v-data-table>

    <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
  </div>
</template>

<script>
import BaseColumn from "@/components/base/BaseColumn";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "DiscountList",
  data() {
    return {
      headers: [
        { text: "Discount Name", value: "" },
        { text: "From Date", value: "" },
        { text: "End Date", value: "" },
        { text: "Percentage", value: "" },
        { text: "Status", value: "is_active" },
        { text: "Action", value: "actions", sortable: false, width: 100 },
      ],
      page: 1,
      disabled: false,
      loading: false,
      branch: [],
      search: {
        search: null,
      },
    };
  },

  created() {
    this.getBranch();
    this.getDiscount();
  },
  methods: {
    ...mapMutations("discount", ["SET_DISCOUNTS"]),
    async getDiscount() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        search: this.search.search,
      };

      await this.$axios
        .get("/master/discount", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_DISCOUNTS(data.discount);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch.data;
        });
    },
    searching() {
      this.page = 1;
      this.getDiscount();
    },
    clear() {
      this.page = 1;
      this.search = {
        search: "",
      };
      this.getDiscount();
    },

    edit(item) {
      this.$router.push("/master/customers/edit/" + item.id);
    },
  },
  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.getDiscount();
    },
  },
  computed: {
    ...mapGetters("discount", {
      Discounts: "Discounts",
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    currentPage: {
      get() {
        return this.Discounts.current_page;
      },
      set(val) {
        return this.$store.commit("discount/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.Discounts.last_page;
      },
    },
  },

  components: {
    BaseColumn,
  },
};
</script>
